import { useMemo } from 'react';
import { useChannelStats } from './useChannelStats';
import { useIsChannelCurator } from './useIsChannelCurator';

export function usePostToChannel({ channelId }: { channelId: string }) {
  const { isLoading: loadingStats, joinStatus } = useChannelStats({ channelId });
  const { isChannelCurator, isLoading: loadingCurators } = useIsChannelCurator({ channelId });

  const isAllowedToPost = useMemo(() => {
    return isChannelCurator && joinStatus === 'JOINED';
  }, [isChannelCurator, joinStatus]);

  const isLoading = loadingStats || loadingCurators;

  return { isAllowedToPost, isLoading };
}
